<template>
    <div>
        <div v-if="this.$store.getters.GetBlock.notifications"></div>
            <div v-if="this.$store.getters.Loaded && this.$store.getters.GetBlock.culture" class="uk-container uk-container-center uk-text-center uk-margin-top uk-position-z-index-negative" style="background-image: none;" uk-scrollspy="cls:uk-animation-slide-bottom;">
            <h1 class="uk-heading" id="culture" v-html="this.$store.getters.GetText.culture.title[this.$store.getters.Lang]"></h1>
            <div>
                <p class="uk-text-lead" v-html="this.$store.getters.GetText.culture.subtitle[this.$store.getters.Lang]" ></p>
                    <!-- First -->
                    <div v-if="this.$store.getters.GetBlock.culture1">
                    <article class="uk-article" v-html="this.$store.getters.GetText.culture.b1[this.$store.getters.Lang]">                    
                    </article>
                    <div class="uk-position-relative uk-light uk-margin-medium-bottom" uk-slideshow>

                    <ul class="uk-slideshow-items uk-position-z-index-negative">
                        <li>
                            <img src="../assets/img/location/krsk2.jpg" alt="" uk-cover>
                        </li>
                        <li>
                            <img src="../assets/img/location/cult1.jpg" alt="" uk-cover>
                        </li>
                        <li>
                            <img src="../assets/img/location/cult2.jpg" alt="" uk-cover>
                        </li>
                        <li>
                            <img src="../assets/img/location/cult3.jpeg" alt="" uk-cover>
                        </li>
                        <li>
                            <img src="../assets/img/location/cult4.jpg" alt="" uk-cover>
                        </li>
                    </ul>                    
                    <div class="uk-position-bottom-center uk-position-small">
                        <ul class="uk-dotnav">
                            <li uk-slideshow-item="0"><a href="#">Item 1</a></li>
                            <li uk-slideshow-item="1"><a href="#">Item 2</a></li>
                            <li uk-slideshow-item="2"><a href="#">Item 3</a></li>
                            <li uk-slideshow-item="3"><a href="#">Item 4</a></li>
                            <li uk-slideshow-item="4"><a href="#">Item 5</a></li>
                            <li uk-slideshow-item="5"><a href="#">Item 6</a></li>
                        </ul>
                    </div>
                    <a class="uk-slidenav-large uk-position-center-left uk-position-small uk-hidden-hover" href="#" uk-slidenav-previous uk-slideshow-item="previous"></a>
                    <a class="uk-slidenav-large uk-position-center-right uk-position-small uk-hidden-hover" href="#" uk-slidenav-next uk-slideshow-item="next"></a>
                    </div>                
                    </div>
                    <!-- Second -->
                    <div v-if="this.$store.getters.GetBlock.culture2">
                    <article class="uk-article" v-html="this.$store.getters.GetText.culture.b2[this.$store.getters.Lang]">                    
                    </article>
                    <div class="uk-position-relative uk-light uk-margin-medium-bottom" uk-slideshow>

                    <ul class="uk-slideshow-items uk-position-z-index-negative">
                        <li>
                            <img src="../assets/img/location/cult2-0.jpeg" alt="" uk-cover>
                        </li>
                        <li>
                            <img src="../assets/img/location/cult2-1.jpg" alt="" uk-cover>
                        </li>
                        <li>
                            <img src="../assets/img/location/cult2-2.jpg" alt="" uk-cover>
                        </li>
                        <li>
                            <img src="../assets/img/location/cult2-3.jpg" alt="" uk-cover>
                        </li>
                        <li>
                            <img src="../assets/img/location/cult2-4.jpg" alt="" uk-cover>
                        </li>
                    </ul>
                    <div class="uk-position-bottom-center uk-position-small">
                        <ul class="uk-dotnav">
                            <li uk-slideshow-item="0"><a href="#">Item 1</a></li>
                            <li uk-slideshow-item="1"><a href="#">Item 2</a></li>
                            <li uk-slideshow-item="2"><a href="#">Item 3</a></li>
                            <li uk-slideshow-item="3"><a href="#">Item 4</a></li>
                            <li uk-slideshow-item="4"><a href="#">Item 5</a></li>
                            <li uk-slideshow-item="5"><a href="#">Item 6</a></li>
                        </ul>
                    </div>
                    <a class="uk-slidenav-large uk-position-center-left uk-position-small uk-hidden-hover" href="#" uk-slidenav-previous uk-slideshow-item="previous"></a>
                    <a class="uk-slidenav-large uk-position-center-right uk-position-small uk-hidden-hover" href="#" uk-slidenav-next uk-slideshow-item="next"></a>
                    </div>                
                    </div>
                    <!-- Thirty -->
                    <div v-if="this.$store.getters.GetBlock.culture3">
                    <article class="uk-article"  v-html="this.$store.getters.GetText.culture.b3[this.$store.getters.Lang]">   
                    </article>
                    <div class="uk-position-relative uk-light uk-margin-medium-bottom" uk-slideshow>

                    <ul class="uk-slideshow-items uk-position-z-index-negative">
                        <li>
                            <img src="../assets/img/location/cult33.jpg" alt="" uk-cover>
                        </li>
                        <li>
                            <img src="../assets/img/location/cult3-0.jpg" alt="" uk-cover>
                        </li>
                        <li>
                            <img src="../assets/img/location/cult3-1.jpg" alt="" uk-cover>
                        </li>
                        <li>
                            <img src="../assets/img/location/cult3-2.jpg" alt="" uk-cover>
                        </li>
                        <li>
                            <img src="../assets/img/location/cult3-3.jpg" alt="" uk-cover>
                        </li>
                        <li>
                            <img src="../assets/img/location/cult3-4.jpg" alt="" uk-cover>
                        </li>
                    </ul>
                    <div class="uk-position-bottom-center uk-position-small">
                        <ul class="uk-dotnav">
                            <li uk-slideshow-item="0"><a href="#">Item 1</a></li>
                            <li uk-slideshow-item="1"><a href="#">Item 2</a></li>
                            <li uk-slideshow-item="2"><a href="#">Item 3</a></li>
                            <li uk-slideshow-item="3"><a href="#">Item 4</a></li>
                            <li uk-slideshow-item="4"><a href="#">Item 5</a></li>
                            <li uk-slideshow-item="5"><a href="#">Item 6</a></li>
                        </ul>
                    </div>
                    <a class="uk-slidenav-large uk-position-center-left uk-position-small uk-hidden-hover" href="#" uk-slidenav-previous uk-slideshow-item="previous"></a>
                    <a class="uk-slidenav-large uk-position-center-right uk-position-small uk-hidden-hover" href="#" uk-slidenav-next uk-slideshow-item="next"></a>
                    </div>                
                    </div>
                    <!-- Forty -->
                    <div v-if="this.$store.getters.GetBlock.culture4">
                    <article class="uk-article" v-html="this.$store.getters.GetText.culture.b4[this.$store.getters.Lang]">   
                    </article>
                    <div class="uk-position-relative uk-light uk-margin-medium-bottom" uk-slideshow>

                    <ul class="uk-slideshow-items uk-position-z-index-negative">
                        <li>
                            <img src="../assets/img/location/cult4-0.jpg" alt="" uk-cover>
                        </li>
                        <li>
                            <img src="../assets/img/location/cult4-1.jpg" alt="" uk-cover>
                        </li>
                        <li>
                            <img src="../assets/img/location/cult4-2.jpg" alt="" uk-cover>
                        </li>                    
                    </ul>
                    <div class="uk-position-bottom-center uk-position-small">
                        <ul class="uk-dotnav">
                            <li uk-slideshow-item="0"><a href="#">Item 1</a></li>
                            <li uk-slideshow-item="1"><a href="#">Item 2</a></li>
                            <li uk-slideshow-item="2"><a href="#">Item 3</a></li>
                        </ul>
                    </div>
                    <a class="uk-slidenav-large uk-position-center-left uk-position-small uk-hidden-hover" href="#" uk-slidenav-previous uk-slideshow-item="previous"></a>
                    <a class="uk-slidenav-large uk-position-center-right uk-position-small uk-hidden-hover" href="#" uk-slidenav-next uk-slideshow-item="next"></a>
                    </div>                
                    
                    <div v-if="this.$store.getters.GetAccess && this.$store.getters.GetBlock.culture_voite && this.$store.getters.User.form=='Offline'">                        
                        <div v-html="this.$store.getters.GetText.culture.voite_description[this.$store.getters.Lang]"></div>
                        <a class="uk-button uk-button-primary uk-text-default" :href="'https://forms.yandex.ru/u/6450ffb9d0468805bd6aac88/?'+'name='+this.$store.getters.User.name+'&email='+this.$store.getters.User.email" target="_blank"><span class="uk-text-large">Перейти к форме</span></a>
                        <!--iframe class="uk-width-1-2@m" :src="'https://forms.yandex.ru/u/6450ffb9d0468805bd6aac88/?iframe=1&'+'name='+this.$store.getters.User.name+'&email='+this.$store.getters.User.email" frameborder="0" height="600" name="ya-form-645207465d2a060e4d107a7c"></iframe-->
                    </div> 
                    </div>           
                    <article v-html="this.$store.getters.GetText.culture.message[this.$store.getters.Lang]" class="uk-article uk-position-z-index-negative"></article>

            </div>            
            </div>

            <div id="modal-reg" uk-modal>
                <div class="uk-modal-dialog uk-modal-body  uk-position-z-index-one">
            </div>
            </div>
    </div>
</template>

